import { render, staticRenderFns } from "./modelo.vue?vue&type=template&id=0040c276&"
import script from "./modelo.vue?vue&type=script&lang=js&"
export * from "./modelo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports